export default function () {
  return {
    customer_name: null,
    remarks: null
  }
}